import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BillingAccountsState } from '../../pages/arc/features/billing-accounts/billing-accounts-models';
import { EmploymentState } from '../../pages/arc/features/employment/employment-model';
import { GroupsState } from '../../pages/arc/features/groups/groups-model';
import { InstitutionState } from '../../pages/arc/features/institutions/institution-model';
import { TcsmStates } from '../../root/tcsm-model';
import { SaveToSessionStorage, TcsmReduxSessionStorageKeys } from '../helpers/session-storage-helper';
import { AppContext, EmployeeContext } from '../models/app-context-model';


function getEmployeeStorageKey(employeeContext: EmployeeContext) {
	switch (employeeContext) {
		case EmployeeContext.GroupAdmin:
			return TcsmReduxSessionStorageKeys.GROUP_ADMIN_SELECT;
		case EmployeeContext.InstitutionAdmin:
			return TcsmReduxSessionStorageKeys.INSTITUTION_ADMIN_SELECT;
		case EmployeeContext.InstitutionEmployee:
			return TcsmReduxSessionStorageKeys.EMPLOYEE_SELECT;
		case EmployeeContext.Participant:
			return TcsmReduxSessionStorageKeys.PARTICIPANT_SELECT;
		default:
			return TcsmReduxSessionStorageKeys.EMPLOYEE_SELECT;
	}
}

export function TcsmStateManager() {

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const employeeState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const groupState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
	const billingAccountState = useSelector<TcsmStates, BillingAccountsState>(state => state.billingAccountsState);

	const appContext = useSelector<TcsmStates, AppContext>(state => state.appContext);

	useEffect(() => {
		if (institutionState?.institutionGuid || institutionState?.institutionGuid) {
			SaveToSessionStorage(
				TcsmReduxSessionStorageKeys.INSTITUTION_SELECT,
				JSON.stringify(
					{
						institutionId: institutionState?.institutionClientNumber,
						guid: institutionState?.institutionGuid,
					},
				),
			);
		}
	}, [institutionState?.institutionGuid, institutionState?.institutionGuid]);

	useEffect(() => {
		if (employeeState?.currentEmployee) {
			SaveToSessionStorage(
				getEmployeeStorageKey(appContext?.employeeContext),
				JSON.stringify(employeeState?.currentEmployee),
			);
		}
	}, [employeeState?.currentEmployee, appContext?.employeeContext]);

	useEffect(() => {
		if (billingAccountState?.currentBillingAccount) {
			SaveToSessionStorage(
				TcsmReduxSessionStorageKeys.BILLING_ACCOUNT_SELECT,
				JSON.stringify(
					{
						billingAccount: billingAccountState?.currentBillingAccount,
						clientNumber: billingAccountState?.currentBillingAccount?.account_owner_client_number,
					},
				),
			);
		}
	}, [billingAccountState?.currentBillingAccount]);

	useEffect(() => {
		if (groupState?.currentGroup) {
			SaveToSessionStorage(
				TcsmReduxSessionStorageKeys.GROUP_SELECT,
				JSON.stringify(groupState?.currentGroup),
			);
		}
	}, [groupState?.currentGroup]);


	return <></>;
}

